import React from 'react';
import { Modal, Header, Body, Footer, FooterItem, Close } from '@zendeskgarden/react-modals';
import { Button } from '@zendeskgarden/react-buttons';

interface ConfirmSerialNumberModalProps {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
  isLoading: boolean;
}

const ConfirmSerialNumberModal: React.FC<ConfirmSerialNumberModalProps> = ({ open, onYes, onNo, isLoading }) => {
  if (!open) return null;
  return (
    <Modal onClose={onNo} style={{width: '80%'}}>
      <Header>Confirm Serial Number</Header>
      <Body>Please make sure you have selected the correct serial number.</Body>
      <Footer>
        <FooterItem>
          <Button isBasic onClick={onNo} disabled={isLoading}>No</Button>
        </FooterItem>
        <FooterItem>
          <Button isPrimary onClick={onYes} disabled={isLoading}>Yes</Button>
        </FooterItem>
      </Footer>
      <Close aria-label="Close modal" onClick={onNo} />
    </Modal>
  );
};

export default ConfirmSerialNumberModal; 